<template>
    <label :class="classes">
        <input :id="`field-${name}-input`"
               :name="name"
               :aria-labelledby="`field-${name}-label`"
               :value="value"
               @input="updateValue"
               :placeholder="placeholder"
               class="field-input"
               type="text"
        >
        <span :id="`field-${name}-label`"
              class="field-label"
              aria-hidden="true"
              v-if="label">
            {{ label }}
        </span>
    </label>
</template>

<script>
  import BaseField from './BaseField';

  export default {
    name: 'TextField',

    extends: BaseField,

    computed: {
      classes () {
        return {
          ...this.baseClasses,
          'field-type-basic': true,
          'field-type-text': true,
        };
      },
    },
  };
</script>

<style scoped>

</style>
